/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TimeAgo/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TimeAgo({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Activities/Content/Activity/ActivityType/Comment/TimeAgo"
  
}) {
let activityDateValueData = fromData.useDataFormat({ viewPath,
context: 'activity',
path: 'date',
format: fromFormat.dateISOToDateAndTimeShort,
})
let activityDateValueData1 = fromData.useDataFormat({ viewPath,
context: 'activity',
path: 'date',
format: fromFormat.timeAgoShort,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="activity.date"
 format="/Data/format.js dateISOToDateAndTimeShort"
 title={activityDateValueData}
 color={dtColorsNeutral600}
 data="activity.date"
 format="/Data/format.js timeAgoShort"
 text={activityDateValueData1}
/>
{children}
</React.Fragment>)
}